import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=6d64d469&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NotFoundComponent.vue"
export default component.exports